<script lang="ts">
  import { onMount } from "svelte";
  import { DateModel, SpotClassModel, SpotModel } from "$models";
  import api, {
    fromApi,
    mapInto,
  } from "$shared/lib/api-parkito2.svelte.ts";
  import { Hor, Label, SpotProduct, WithResource } from "$components";
  const {
    siteId,
    spotClassId, // a "spot class id" is the set of all of its tag ids,
    startDate,
    spotGroup,
  }: {
    siteId: string;
    startDate: DateModel;
    spotClassId: string[];
    spotGroup?: SpotModel;
  } = $props();
  const spotClassReq = fromApi((date: DateModel) =>
    api.publicSearchSpotClasses({
      body: {
        siteIds: [siteId],
        dateRange: {
          start: date.format("YYYY-MM-DD"),
          end: date.format("YYYY-MM-DD"),
        },
      },
    })
      .then(mapInto((data) => {
        const asdf = data
          .filter((c) =>
            spotClassId.every((id) => c.tags.map((t) => t.id).includes(id))
          )
          .filter((c) => c.tags.every(({ id }) => spotClassId.includes(id)))
          .map((d) => new SpotClassModel(d));
        return asdf;
      }))
  );
  onMount(() => $spotClassReq.load(startDate));
</script>

<WithResource api={spotClassReq}>
  {#snippet child(spotClasses)}
    {#if spotClasses.length > 0}
      {@const spotClass = spotClasses[0]}
      <Hor outset>
        <SpotProduct spotGroup={spotGroup?.toMyPagesSpot()} {spotClass} />
      </Hor>
    {:else}
      <Label type="error"
      >Något gick fel, vi hittade inte platsen som du är intresserad av</Label>
    {/if}
  {/snippet}
</WithResource>
